import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import Booking_History from "../booking history";

function Inquries() {
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;
  AOS.init();

  const [userInfo, setUserInfo] = useState({});
  // console.log(userInfo);
  useEffect(() => {
    const token = localStorage.getItem("aqua");

    try {
      fetch(`${baseUrl}/userInfo/getUserDetails`, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Failed to fetch booking details");
          }
        })
        .then((data) => {
          // console.log("sc", data.result);
          setUserInfo(data.result);
        })
        .catch((error) => {
          console.error("Error fetching booking details:", error);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  const [isloading, setIsloading] = useState(true);

  useEffect(() => {
    const fakeDatafetch = () => {
      setTimeout(() => {
        setIsloading(false);
      }, 2000);
    };
    fakeDatafetch();
  }, []);

  return (
    <>
      <div className="">
        {/* <div className="h-full w-full absolute lg:top-[115px] top-[80px] left-0 z-0">
          <div className="relative h-full w-full">
            <img
              src="./assets/bg_blue.png"
              alt=""
              className="object-fill h-full w-full absolute top-0 -z-20"
            />
            <img
              src="./assets/bg_green.png"
              alt=""
              className="object-fill h-full w-full absolute top-0 -z-40"
            />
          </div>
        </div> */}
        <div className="min-h-screen h-full relative overflow-hidden">
          <div className="min-h-screen h-full relative mb-10 overflow-hidden">
            <div className="flex items-center justify-center pt-20 lg:justify-start h-screen xl:px-[200px] lg:px-5">
              <div
                className="w-[200px] text-[#ffffff] hidden lg:block"
                data-aos="fade-right"
                data-aos-duration="2000"
              >
                <Link to="/profile">
                  <div className="flex items-center">
                    <svg
                      width="28"
                      height="29"
                      viewBox="0 0 28 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.6673 11C18.6673 12.2377 18.1757 13.4247 17.3005 14.2998C16.4253 15.175 15.2383 15.6667 14.0007 15.6667C12.763 15.6667 11.576 15.175 10.7008 14.2998C9.82565 13.4247 9.33398 12.2377 9.33398 11C9.33398 9.76232 9.82565 8.57534 10.7008 7.70017C11.576 6.825 12.763 6.33333 14.0007 6.33333C15.2383 6.33333 16.4253 6.825 17.3005 7.70017C18.1757 8.57534 18.6673 9.76232 18.6673 11ZM16.334 11C16.334 11.6188 16.0882 12.2123 15.6506 12.6499C15.213 13.0875 14.6195 13.3333 14.0007 13.3333C13.3818 13.3333 12.7883 13.0875 12.3507 12.6499C11.9132 12.2123 11.6673 11.6188 11.6673 11C11.6673 10.3812 11.9132 9.78767 12.3507 9.35008C12.7883 8.9125 13.3818 8.66667 14.0007 8.66667C14.6195 8.66667 15.213 8.9125 15.6506 9.35008C16.0882 9.78767 16.334 10.3812 16.334 11Z"
                        fill="#A3D284"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.0003 1.66666C6.91283 1.66666 1.16699 7.4125 1.16699 14.5C1.16699 21.5875 6.91283 27.3333 14.0003 27.3333C21.0878 27.3333 26.8337 21.5875 26.8337 14.5C26.8337 7.4125 21.0878 1.66666 14.0003 1.66666ZM3.50033 14.5C3.50033 16.9383 4.33216 19.183 5.72633 20.9657C6.70543 19.6799 7.96854 18.6379 9.417 17.921C10.8655 17.2042 12.46 16.8319 14.0762 16.8333C15.6714 16.8318 17.2459 17.1944 18.6797 17.8936C20.1136 18.5927 21.3689 19.6099 22.3502 20.8677C23.361 19.5419 24.0416 17.9944 24.3357 16.3534C24.6298 14.7123 24.5288 13.0248 24.0412 11.4305C23.5536 9.83617 22.6934 8.38089 21.5317 7.18504C20.37 5.9892 18.9403 5.08717 17.3608 4.55359C15.7813 4.02002 14.0974 3.87023 12.4485 4.11663C10.7996 4.36303 9.23308 4.99854 7.87856 5.97056C6.52403 6.94258 5.42044 8.22318 4.65909 9.70639C3.89775 11.1896 3.50054 12.8328 3.50033 14.5ZM14.0003 25C11.5899 25.0036 9.2523 24.1744 7.38299 22.6527C8.13541 21.5755 9.13689 20.6961 10.3022 20.0891C11.4675 19.4822 12.7622 19.1657 14.0762 19.1667C15.3737 19.1656 16.6527 19.4742 17.8071 20.0667C18.9614 20.6592 19.9578 21.5185 20.7133 22.5733C18.8295 24.1445 16.4533 25.0034 14.0003 25Z"
                        fill="#A3D284"
                      />
                    </svg>
                    <p className="ml-5 font-[500] text-[20px] text-[#234971]">My Profile</p>
                  </div>
                </Link>
                <Link to="/inquries">
                  <div className="flex items-center mt-9">
                    <svg
                      width="28"
                      height="29"
                      viewBox="0 0 28 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.51667 5.85033C5.83301 6.534 5.83301 7.633 5.83301 9.83333V20.3333C5.83301 22.5337 5.83301 23.6327 6.51667 24.3163C7.20034 25 8.29934 25 10.4997 25H17.4997C19.7 25 20.799 25 21.4827 24.3163C22.1663 23.6327 22.1663 22.5337 22.1663 20.3333V9.83333C22.1663 7.633 22.1663 6.534 21.4827 5.85033C20.799 5.16667 19.7 5.16667 17.4997 5.16667H10.4997C8.29934 5.16667 7.20034 5.16667 6.51667 5.85033ZM10.4997 9.83333C10.1903 9.83333 9.89351 9.95625 9.67472 10.175C9.45592 10.3938 9.33301 10.6906 9.33301 11C9.33301 11.3094 9.45592 11.6062 9.67472 11.825C9.89351 12.0437 10.1903 12.1667 10.4997 12.1667H17.4997C17.8091 12.1667 18.1058 12.0437 18.3246 11.825C18.5434 11.6062 18.6663 11.3094 18.6663 11C18.6663 10.6906 18.5434 10.3938 18.3246 10.175C18.1058 9.95625 17.8091 9.83333 17.4997 9.83333H10.4997ZM10.4997 14.5C10.1903 14.5 9.89351 14.6229 9.67472 14.8417C9.45592 15.0605 9.33301 15.3572 9.33301 15.6667C9.33301 15.9761 9.45592 16.2728 9.67472 16.4916C9.89351 16.7104 10.1903 16.8333 10.4997 16.8333H17.4997C17.8091 16.8333 18.1058 16.7104 18.3246 16.4916C18.5434 16.2728 18.6663 15.9761 18.6663 15.6667C18.6663 15.3572 18.5434 15.0605 18.3246 14.8417C18.1058 14.6229 17.8091 14.5 17.4997 14.5H10.4997ZM10.4997 19.1667C10.1903 19.1667 9.89351 19.2896 9.67472 19.5084C9.45592 19.7272 9.33301 20.0239 9.33301 20.3333C9.33301 20.6428 9.45592 20.9395 9.67472 21.1583C9.89351 21.3771 10.1903 21.5 10.4997 21.5H15.1663C15.4758 21.5 15.7725 21.3771 15.9913 21.1583C16.2101 20.9395 16.333 20.6428 16.333 20.3333C16.333 20.0239 16.2101 19.7272 15.9913 19.5084C15.7725 19.2896 15.4758 19.1667 15.1663 19.1667H10.4997Z"
                        fill="#A3D284"
                      />
                    </svg>
                    <p className="ml-5 font-[700] text-[20px] text-[#234971]">My Inquiries</p>
                  </div>
                </Link>
                <div className="flex items-center mt-9 cursor-pointer">
                  <svg
                    width="28"
                    height="29"
                    viewBox="0 0 28 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.66699 14.5C4.66699 14.8094 4.78991 15.1062 5.0087 15.325C5.22749 15.5438 5.52424 15.6667 5.83366 15.6667H14.6887L12.0053 18.3383C11.896 18.4468 11.8092 18.5758 11.75 18.718C11.6907 18.8602 11.6602 19.0127 11.6602 19.1667C11.6602 19.3207 11.6907 19.4732 11.75 19.6153C11.8092 19.7575 11.896 19.8865 12.0053 19.995C12.1138 20.1044 12.2428 20.1911 12.385 20.2504C12.5272 20.3096 12.6796 20.3401 12.8337 20.3401C12.9877 20.3401 13.1402 20.3096 13.2823 20.2504C13.4245 20.1911 13.5535 20.1044 13.662 19.995L18.3287 15.3283C18.4349 15.2174 18.5181 15.0865 18.5737 14.9433C18.6903 14.6593 18.6903 14.3407 18.5737 14.0567C18.5181 13.9135 18.4349 13.7826 18.3287 13.6717L13.662 9.005C13.5532 8.89622 13.4241 8.80994 13.2819 8.75107C13.1398 8.6922 12.9875 8.6619 12.8337 8.6619C12.6798 8.6619 12.5275 8.6922 12.3854 8.75107C12.2432 8.80994 12.1141 8.89622 12.0053 9.005C11.8965 9.11378 11.8103 9.24292 11.7514 9.38505C11.6925 9.52717 11.6622 9.6795 11.6622 9.83334C11.6622 9.98717 11.6925 10.1395 11.7514 10.2816C11.8103 10.4238 11.8965 10.5529 12.0053 10.6617L14.6887 13.3333H5.83366C5.52424 13.3333 5.22749 13.4563 5.0087 13.675C4.78991 13.8938 4.66699 14.1906 4.66699 14.5ZM19.8337 2.83334H8.16699C7.23873 2.83334 6.3485 3.20208 5.69212 3.85846C5.03574 4.51484 4.66699 5.40508 4.66699 6.33334V9.83334C4.66699 10.1428 4.78991 10.4395 5.0087 10.6583C5.22749 10.8771 5.52424 11 5.83366 11C6.14308 11 6.43982 10.8771 6.65862 10.6583C6.87741 10.4395 7.00033 10.1428 7.00033 9.83334V6.33334C7.00033 6.02392 7.12324 5.72717 7.34203 5.50838C7.56083 5.28959 7.85757 5.16667 8.16699 5.16667H19.8337C20.1431 5.16667 20.4398 5.28959 20.6586 5.50838C20.8774 5.72717 21.0003 6.02392 21.0003 6.33334V22.6667C21.0003 22.9761 20.8774 23.2728 20.6586 23.4916C20.4398 23.7104 20.1431 23.8333 19.8337 23.8333H8.16699C7.85757 23.8333 7.56083 23.7104 7.34203 23.4916C7.12324 23.2728 7.00033 22.9761 7.00033 22.6667V19.1667C7.00033 18.8573 6.87741 18.5605 6.65862 18.3417C6.43982 18.1229 6.14308 18 5.83366 18C5.52424 18 5.22749 18.1229 5.0087 18.3417C4.78991 18.5605 4.66699 18.8573 4.66699 19.1667V22.6667C4.66699 23.5949 5.03574 24.4852 5.69212 25.1415C6.3485 25.7979 7.23873 26.1667 8.16699 26.1667H19.8337C20.7619 26.1667 21.6522 25.7979 22.3085 25.1415C22.9649 24.4852 23.3337 23.5949 23.3337 22.6667V6.33334C23.3337 5.40508 22.9649 4.51484 22.3085 3.85846C21.6522 3.20208 20.7619 2.83334 19.8337 2.83334Z"
                      fill="#A3D284"
                    />
                  </svg>
                  <p className="ml-5 text-[20px] text-[#234971]">Sign Out</p>
                </div>
              </div>
              <div
                className="xl:ml-10"
                data-aos="fade-left"
                data-aos-duration="2000"
              >
                <p className="lg:text-[36px] text-[26px] text-[#234971] font-[700] mx-2 md:mx-0">
                  Inquiries History
                </p>
                <Booking_History />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Inquries;
